<template>
  <section
    class="edito-carousel"
    :class="{
      '-featured': featured,
      '-no-pagination': !link || !linkLabel,
    }"
  >
    <ui-wrapper>
      <component
        :is="titleTag"
        v-if="title"
        class="section-title">
        <span v-html="title"></span>
      </component>

      <div mobile-only no-overflow>
        <ul :id="sliderId" class="edito-carousel-wrapper">
          <li
            v-for="(card, index) in cards"
            :key="card.uid || index"
            class="edito-carousel-item"
          >
            <edito-card v-bind="card" @click="handleCardClick" />
          </li>
        </ul>
      </div>
      <cta-label
        v-if="link && linkLabel"
        v-bind="link"
        variant="secondary"
        class="edito-carousel-cta"
        >{{ linkLabel }}</cta-label
      >
    </ui-wrapper>
  </section>
</template>

<script>
import { defineAsyncComponent } from 'vue';
const UiSlider = defineAsyncComponent(() => import('Molecules/ui-slider'));
const EditoCard = defineAsyncComponent(() => import('Molecules/edito-card'));
const CtaLabel = defineAsyncComponent(() => import('Atoms/cta-label'));
const UiWrapper = defineAsyncComponent(() => import('Foundations/ui-wrapper'));

export default {
  name: 'EditoCarousel',
  components: { UiSlider, EditoCard, CtaLabel, UiWrapper },
  props: {
    featured: {
      type: Boolean,
      default: false,
    },
    sliderId: {
      type: String,
      default: null,
    },
    titleTag: {
      type: String,
      default: 'h2',
    },
    title: {
      type: String,
      default: null,
    },
    cards: {
      type: Array,
      required: true,
    },
    link: {
      type: Object,
      default: null,
    },
    linkLabel: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleCardClick() {
      this.$emit('card-click');
    },
  },
};
</script>

<style lang="scss">
.edito-carousel {
  width: 100%;
  @include spacing-top;

  &.-no-pagination {
    margin-bottom: april-rem($spacing-2xl);
  }

  .edito-carousel-wrapper {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  &.-featured {
    .ui-wrapper {
      padding-bottom: april-rem($spacing-4xl);
      border-bottom: april-rem(1) solid $color-medium-gray;
    }

    .section-title {
      text-align: center;
      margin-bottom: april-rem($spacing-xl);
      @include title-2;
    }
  }

  .ui-wrapper {
    display: flex;
    flex-direction: column;
  }

  .section-title {
    margin-top: 0;
    margin-bottom: april-rem($spacing-l);
  }

  .edito-carousel-item {
    display: flex;
    justify-content: center;
    padding: 0 april-rem($spacing-s);
    height: auto;
    min-width: 0;
  }

  .edito-carousel-cta {
    margin: april-rem($spacing-l) auto 0;
  }

  @media #{$mq-mobile-tablet} {
    padding-bottom: 0;

    .edito-carousel-item {
      padding: 0;
      margin-bottom: april-rem($spacing-m);
    }
  }

  @media #{$mq-medium} {
    .edito-carousel-wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: april-rem($spacing-2xl);
      grid-auto-rows: 1fr;
    }

    .edito-carousel-item {
      padding: 0 0;
    }

    .edito-carousel-cta {
      margin: april-rem($spacing-2xl) auto 0;
    }

    &.-featured {
      .section-title {
        margin-bottom: april-rem($spacing-2xl);
      }
    }
  }
}
</style>
